import { CrudStore } from 'core/types/crudStore'

export const getCrudRoles = () => CrudStore.get('Dropdowns', 'JBPContactType')
